import { render, staticRenderFns } from "./LeaveTransactionPropertyGroup.vue?vue&type=template&id=6f2d051e&"
import script from "./LeaveTransactionPropertyGroup.vue?vue&type=script&lang=js&"
export * from "./LeaveTransactionPropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2d051e')) {
      api.createRecord('6f2d051e', component.options)
    } else {
      api.reload('6f2d051e', component.options)
    }
    module.hot.accept("./LeaveTransactionPropertyGroup.vue?vue&type=template&id=6f2d051e&", function () {
      api.rerender('6f2d051e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/LeaveTransactionPropertyGroup.vue"
export default component.exports